document.addEventListener('DOMContentLoaded', function () {
    if (!document.body.classList.contains('page-cart')) {
        return;
    }
    const productId = 104;
    let cartProducts = window.prestashop.cart.products || [];

    const productUrl = prestashop.cart.products[0].add_to_cart_url;

    const urlParams = new URLSearchParams(productUrl.split('?')[1]);
    const csrfToken = urlParams.get('token');

    function addProductToCart() {
        // Vérifier si le produit avec l'ID 104 est déjà dans le panier
        let productExists = false;
  
        // Récupérer les produits dans le panier via window.prestashop.cart
        const cartProducts = window.prestashop.cart.products || [];
  
        // Si le panier est vide, ne rien faire
        if (cartProducts.length === 0) {
            return;
        }
  
        // Vérifier si le produit existe déjà dans le panier
        cartProducts.forEach(product => {
            if (product.id_product == productId) {
                console.log('aucun produit dans le panier');
                productExists = true;
            }
        });
  
        // Si le produit n'existe pas dans le panier, l'ajouter avec une quantité de 1
        if (!productExists) {
            if (productUrl) {
                // Utiliser le token dans la requête fetch
                fetch('/index.php?controller=cart&add=1&id_product=' + productId + '&qty=1&token=' + csrfToken, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    credentials: 'same-origin'  // Assurez-vous que les cookies sont envoyés
                }).then(response => {
                    location.reload(); 
                })
            }
        }
    }
  
    function removeProductFromCart(productId) {
        if (productUrl) {
            // Utiliser le token dans la requête fetch
            fetch('/index.php?controller=cart&delete=1&id_product=' + productId + '&token=' + csrfToken, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'same-origin'  // Assurez-vous que les cookies sont envoyés
            }).then(response => {
                location.reload(); 
            })
        }
    }
  
    if (cartProducts.length === 1 && cartProducts[0].id_product == productId) {
        removeProductFromCart(productId);
    } else {
        addProductToCart();
    }

    setInterval(function() {
        let cartProducts = window.prestashop.cart.products || [];

        if (cartProducts.length === 1 && cartProducts[0].id_product == productId) {
            removeProductFromCart(productId);
        }
    }, 1500);
});
  
  